<ui-app-layout>
  <ui-side-menu>
    <section class="ui-menu-header">
      <div class="header-row">
        <ui-jct-logo *ngIf="!appLayout.isMobile" [solid]="true" [includePadding]="false" [width]="62"> </ui-jct-logo>

        <span class="ui-menu-brand">
          <span class="ui-menu-brand__title" i18n>המרכז האקדמי לב</span>
          <span class="ui-menu-brand__subtitle" i18n>מערכת הרישום</span>
        </span>
      </div>
    </section>

    <ui-menu-item route="/admin/login">
      <ui-menu-content icon="lock_open" i18n> התחברות למערכת </ui-menu-content>
    </ui-menu-item>
  </ui-side-menu>

  <section ui-toolbar-header class="ui-toolbar-header">
    <span class="ui-toolbar-brand" *ngIf="appLayout.isMobile">
      <ui-jct-logo [solid]="true" [includePadding]="false" [width]="40"></ui-jct-logo>
      <span class="ui-toolbar-brand__text">
        <span class="ui-toolbar-brand__title" i18n>המרכז האקדמי לב</span>
        <span class="ui-toolbar-brand__subtitle" i18n>מערכת הרישום</span>
      </span>
    </span>

    <span *ngIf="!appLayout.isMobile">
      {{ pageTitle?.current }}
    </span>
  </section>

  <section ui-toolbar-actions class="ui-toolbar-actions"></section>
</ui-app-layout>
